import { defineMessages } from 'react-intl';

/** The copy of the consent page (design: music24-oauth-consent "a Consent"). */
export const oauthConsentMessages = defineMessages({
  titleWrite: {
    id: 'app.sml.oauthConsent.title.write',
    defaultMessage: '{app} wants to work with your MUSIC24 account',
  },
  titleRead: { id: 'app.sml.oauthConsent.title.read', defaultMessage: '{app} wants to read your MUSIC24 data' },

  badgeVerified: { id: 'app.sml.oauthConsent.identity.badge.verified', defaultMessage: 'Verified app' },
  badgeUnverified: { id: 'app.sml.oauthConsent.identity.badge.unverified', defaultMessage: 'Unverified app' },
  badgeAppFrom: { id: 'app.sml.oauthConsent.identity.badge.appFrom', defaultMessage: 'App from' },
  redirect: { id: 'app.sml.oauthConsent.identity.redirect', defaultMessage: 'Sends you back to {host}' },
  knownRedirect: {
    id: 'app.sml.oauthConsent.identity.knownRedirectLine',
    defaultMessage: 'The sign-in goes only to {host}',
  },
  unverifiedLine: {
    id: 'app.sml.oauthConsent.identity.unverifiedLine',
    defaultMessage: 'MUSIC24 cannot check who made it. It sends you back to {host}.',
  },

  warningTitle: { id: 'app.sml.oauthConsent.warning.title', defaultMessage: 'Check this app before you approve' },
  warningText: {
    id: 'app.sml.oauthConsent.identity.cannotConfirm',
    defaultMessage:
      'MUSIC24 cannot confirm that this app is ChatGPT or Claude, whatever its name says. Approve it only if you trust where it comes from.',
  },

  accountLabel: { id: 'app.sml.oauthConsent.account.label', defaultMessage: 'Connects to' },
  signedInAs: { id: 'app.sml.oauthConsent.account.signedInAs', defaultMessage: 'Signed in as {email}' },
  otherWorkspace: {
    id: 'app.sml.oauthConsent.account.otherWorkspace',
    defaultMessage: 'To connect another workspace, open it in MUSIC24 first. Then connect the app again.',
  },

  canSee: { id: 'app.sml.oauthConsent.permissions.canSee', defaultMessage: '{app} can see' },
  canDo: { id: 'app.sml.oauthConsent.permissions.canDo', defaultMessage: '{app} can do' },
  // Each row must be true for the MCP tools (music24-website apiDocs/mcpTools.generated.json).
  // The rows changed on 2026-10-11, so they have new ids: an old translation says less.
  seeCatalog: {
    id: 'app.sml.oauthConsent.permissions.see.catalogLyrics',
    defaultMessage: 'Your artists, songs, releases and lyrics',
  },
  seeNumbers: {
    id: 'app.sml.oauthConsent.permissions.see.money',
    defaultMessage: 'Your streaming, earnings and social numbers',
  },
  seeLinks: {
    id: 'app.sml.oauthConsent.permissions.see.linksFans',
    defaultMessage: 'Your SmartLinks, pre-saves and fans',
  },
  seeWork: {
    id: 'app.sml.oauthConsent.permissions.see.work',
    defaultMessage: 'Your assets, posts and connected services',
  },
  seeWorkspace: {
    id: 'app.sml.oauthConsent.permissions.see.workspace',
    defaultMessage: 'Your workspace: the plan, the team and the credits',
  },
  seeOutreach: {
    id: 'app.sml.oauthConsent.permissions.see.outreach',
    defaultMessage: 'Your Pitch campaigns, the playlists that fit and the replies',
  },
  doAssets: {
    id: 'app.sml.oauthConsent.permissions.do.aiAssets',
    defaultMessage: 'Make AI reels, AI covers, music videos and other assets. Some use credits.',
  },
  doPosts: {
    id: 'app.sml.oauthConsent.permissions.do.publish',
    defaultMessage: 'Plan, schedule and publish posts and videos',
  },
  doLinks: {
    id: 'app.sml.oauthConsent.permissions.do.linksPresaves',
    defaultMessage: 'Create, change and delete SmartLinks and pre-saves',
  },
  doCatalog: {
    id: 'app.sml.oauthConsent.permissions.do.catalog',
    defaultMessage: 'Add and change artists, songs and files, and delete songs',
  },
  doShare: {
    id: 'app.sml.oauthConsent.permissions.do.share',
    defaultMessage: 'Share files and chart pages with a public link',
  },
  doSettings: {
    id: 'app.sml.oauthConsent.permissions.do.settings',
    defaultMessage: 'Change notifications, your watchlist and connected services',
  },
  doOutreach: {
    id: 'app.sml.oauthConsent.permissions.do.outreach',
    defaultMessage: 'Start a Pitch campaign. It sends the pitches from your mailbox.',
  },
  doNothing: {
    id: 'app.sml.oauthConsent.permissions.do.nothing',
    defaultMessage: 'Nothing. It cannot change, post or delete anything.',
  },
  promise: {
    id: 'app.sml.oauthConsent.promise',
    defaultMessage: 'MUSIC24 asks you before anything is posted, shared, deleted or uses credits.',
  },

  deny: { id: 'app.sml.oauthConsent.deny', defaultMessage: 'Deny' },
  approve: { id: 'app.sml.oauthConsent.approve', defaultMessage: 'Approve' },
  approveAnyway: { id: 'app.sml.oauthConsent.approveAnyway', defaultMessage: 'Approve anyway' },
  foot: {
    id: 'app.sml.oauthConsent.footAssistants',
    defaultMessage: 'You can remove this app at any time in <b>Settings → AI assistants</b>. It works on every plan.',
  },

  loading: { id: 'app.sml.oauthConsent.loading', defaultMessage: 'Loading the request' },
  errorHint: {
    id: 'app.sml.oauthConsent.error.hint',
    defaultMessage: 'If it does not load, go back to the app and connect again.',
  },
  errorIncomplete: {
    id: 'app.sml.oauthConsent.error.incomplete',
    defaultMessage: 'This link is not complete. Go back to the app and connect again.',
  },
});
